/**
 * @generated SignedSource<<e5c558e20895661a32c474723d0f88ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DownloadInvoiceAttachmentInput = {
  id: string;
  sha1: string;
};
export type DraftInvoiceViewDownloadInvoiceAttachmentMutation$variables = {
  input: DownloadInvoiceAttachmentInput;
};
export type DraftInvoiceViewDownloadInvoiceAttachmentMutation$data = {
  readonly downloadInvoiceAttachment: {
    readonly filename: string;
    readonly uri: string;
  } | null | undefined;
};
export type DraftInvoiceViewDownloadInvoiceAttachmentMutation = {
  response: DraftInvoiceViewDownloadInvoiceAttachmentMutation$data;
  variables: DraftInvoiceViewDownloadInvoiceAttachmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TemporaryDownload",
    "kind": "LinkedField",
    "name": "downloadInvoiceAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftInvoiceViewDownloadInvoiceAttachmentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DraftInvoiceViewDownloadInvoiceAttachmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7eb5715bc3bdf692f373830540381a46",
    "id": null,
    "metadata": {},
    "name": "DraftInvoiceViewDownloadInvoiceAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation DraftInvoiceViewDownloadInvoiceAttachmentMutation(\n  $input: DownloadInvoiceAttachmentInput!\n) {\n  downloadInvoiceAttachment(input: $input) {\n    uri\n    filename\n  }\n}\n"
  }
};
})();

(node as any).hash = "97a82058237dea01b97add7d1de2f3e2";

export default node;
